import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
//import HomeIcon from '@mui/icons-material/Home';
import HomeIcon from '@mui/icons-material/Home';
import LockIcon from '@mui/icons-material/Lock';
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { LoginResponse } from "../../dto/auth.dto";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIocn from '@mui/icons-material/Settings';
import HelpIcon from '@mui/icons-material/Help';
import AddModeratorOutlinedIcon from "@mui/icons-material/AddModeratorOutlined";
import AddLocationAltIcon from "@mui/icons-material/AddLocation";
import InfoIcon from '@mui/icons-material/Info';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import ReorderIcon from '@mui/icons-material/Reorder';
import PaidIcon from '@mui/icons-material/CreditCard';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getAuth } from '../../assets/redux/AuthRedux';
import { connect, useSelector, useDispatch } from 'react-redux';
import { Box, SwipeableDrawer, ListItem, ListItemIcon, ListItemText, Divider, Avatar, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";
import './styles.css';
import { getDictionary } from '../../assets/redux/DictionaryRedux';
import MoneyText from '../MoneyText';
const useStyles = makeStyles((theme: any) => ({
  list: {
    width: 250,
    backgroundColor: theme.color.sidbarBackgroundColor,
  },
  fullList: {
    width: 'auto',
  },
  link: {
    textDecoration: "none",

  },
  menuItem: {
    textAlign: "right !important" as any
  },
  photo: {
    width: "80px",
    height: "80px"
  },
  icon: {
    color: theme.color.iconPageSetting
  },
}));
interface Iprops {
  isVisible: boolean;
  closeMenu: any;
  onClickSingout: Function
}
const SideMenu = (props: Iprops) => {
  const dic = useSelector((state: any) => getDictionary(state.DicRedux));
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  let isAuth = false;
  const auth = useSelector((state: any) => getAuth(state.AuthRedux)) as LoginResponse;
  isAuth = auth && auth.token ? true : false;

  const toggleDrawer = (anchor: any, open: any) => (event: any) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    // setState({ ...state, [anchor]: open });
  };
  useEffect(() => {
    // if (isAuth) {
    //   dispatch({ type: 'SetUserProfile', profileData: { instagramId: auth.instagramId, avatar: auth.image, fullname: auth.firstName + ' ' + auth.lastName } });
    // }
    // else
    //   dispatch({ type: 'SetUserProfile', profileData: false });
  }, [isAuth, location.pathname])
  return <SwipeableDrawer
    anchor='left'
    open={props.isVisible}
    onClose={toggleDrawer('right', false)}
    onOpen={toggleDrawer('right', true)}
    onClick={props.closeMenu}
  >
    <div
      className={classes.list}
      role="presentation"
      onClick={props.closeMenu}
      onKeyDown={props.closeMenu}
    >
      <Link hidden={!isAuth} to="/app/home" onClick={props.closeMenu} className={classes.link}>
        <ListItem button >
          <ListItemText primary={
            <Box display="flex" justifyContent="center" flexGrow={1} alignItems="center" flexWrap="nowrap" flexDirection="column" mb={1}>
              <Avatar src={auth.photoSrc} className={classes.photo} />
              <Typography component="div">
                {auth?.fullName}
              </Typography>
              <Typography>
                {auth?.nationalCode}
              </Typography>
              <Typography>
                {auth?.mobile}
              </Typography>
              <Typography>
                <Box fontWeight="bold" fontSize={18}>
                  {dic.creditUser} <MoneyText value={auth?.credit} />

                </Box>
              </Typography>
            </Box>
          } />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/fieldList" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><HomeIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.home} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/propertyPackages" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><ShoppingBasketIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.propertyPackages} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/addAttendance" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><AddLocationAltIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.addAttendance} />
        </ListItem>
      </Link>
      <Link hidden={!isAuth} to="/app/attendanceList" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><AssignmentLateIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.customerAttendanceList} />
        </ListItem>
      </Link>

      <Link hidden={!isAuth} to="/app/orders" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><ReorderIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.orderList} />
        </ListItem>
      </Link>
      <Link hidden={!isAuth} to="/app/installments" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><PaidIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.installments} />
        </ListItem>
      </Link>

      <Link hidden={!isAuth} to="/app/profile" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><AccountCircleIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.profile} />
        </ListItem>

      </Link>

      <Link hidden={!isAuth} to="/app/setting" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><SettingsIocn className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.settings} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/ticketAdd" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><AddModeratorOutlinedIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.addTicket} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/tickets" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><HelpCenterIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.tickets} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/aboutMe" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><InfoIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.aboutMe} />
        </ListItem>

      </Link>
      <Link hidden={!isAuth} to="/app/help" onClick={props.closeMenu} className={classes.link}>
        <ListItem button className={classes.menuItem}>
          <ListItemIcon><HelpIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.help} />
        </ListItem>

      </Link>
      <ListItem button hidden={!isAuth} onClick={e => props.onClickSingout()} className={classes.menuItem}>
        <ListItemIcon ><ExitToAppIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
        <ListItemText primary={dic.signOut} />
      </ListItem>
      <Link hidden={isAuth} to="/auth/register" onClick={props.closeMenu} className={classes.link}>
        <ListItem button>
          <ListItemIcon><LockIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.register} />
        </ListItem>

      </Link>
      <Link hidden={isAuth} to="/auth/signin" onClick={props.closeMenu} className={classes.link} >
        <ListItem button>
          <ListItemIcon><LockIcon className={classes.icon} fontSize="large" /> </ListItemIcon>
          <ListItemText primary={dic.login} />
        </ListItem>

      </Link>
      <Divider />

    </div>

  </SwipeableDrawer>

};

export default SideMenu;
